import { render, staticRenderFns } from "./PaintEdition.vue?vue&type=template&id=31be90f0&scoped=true&"
import script from "./PaintEdition.vue?vue&type=script&lang=js&"
export * from "./PaintEdition.vue?vue&type=script&lang=js&"
import style0 from "./PaintEdition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PaintEdition.vue?vue&type=style&index=1&id=31be90f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be90f0",
  null
  
)

export default component.exports